import { render, staticRenderFns } from "./message.vue?vue&type=template&id=23496884&scoped=true&lang=pug"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=23496884&prod&lang=scss&scoped=true&external"
import style1 from "./message.vue?vue&type=style&index=1&id=23496884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23496884",
  null
  
)

export default component.exports